import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdvanceSearchService } from '../../services/Advance-search/advance-search.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../services/toast/toast.service';
// import { HotToastService } from '@ngneat/hot-toast'; // or your toaster import

@Component({
  selector: 'app-edit-fc',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './edit-fc.component.html',
  styleUrl: './edit-fc.component.scss'
})
export class EditFcComponent implements OnInit {
  selectedMemberCode!: string;
  searchFamilyCode: string = '';
  filterData: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditFcComponent>,
    private advanceSearch: AdvanceSearchService,
    private toaster: ToastService,
  ) {}

  ngOnInit(): void {
    console.log(this.data);
  }

  onFamilyCodeChange(value: string): void {
    this.filterData = [];
    this.selectedMemberCode = '';

    if (value?.length === 12 && value !== this.data.devoteeFamilyCode) {
      this.advanceSearch.fetchPhilDetails(value).subscribe({
        next: (res) => {
          if (res.data.length > 0) {
            this.filterData = res.data;
          } else {
            this.toaster.error('No members found for this family code');
          }
        },
        error: (err) => {
          this.toaster.error(err.error.message);
        }
      });
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  continue(): void {
  const selectedMember = this.filterData.find(
    (m) => m.memberCode === this.selectedMemberCode
  );

  // Just close the dialog with the updated data — no API call
  this.dialogRef.close({
    familyCode: this.searchFamilyCode,
    fullName: selectedMember?.fullName,
    memberCode: this.selectedMemberCode
  });
}
}